import Button from "components/EvtKit/button/Button"
import IconCloudDownload from "components/EvtKit/icons/IconCloudDownload"
import { useExportFile } from "hooks/useExportFile"

import { memo, useCallback } from "react"

interface DownloadBreakdownPdfProps {
  pdfLink: string
}

const DownloadBreakdownPDF = (props: DownloadBreakdownPdfProps) => {
  const { pdfLink } = props

  const { downloadFileByLink } = useExportFile({ fileName: "relatorio.pdf", fileType: "pdf" })

  const handleDownload = useCallback(() => {
    if (!pdfLink || pdfLink.length === 0) {
      return
    }

    downloadFileByLink(pdfLink)
  }, [pdfLink, downloadFileByLink])

  return (
    <Button
      className="no-border no-padding"
      label="Baixar PDF"
      iconLeft={<IconCloudDownload />}
      onClick={handleDownload}
      isSmall
    />
  )
}

export default memo(DownloadBreakdownPDF)
